import { useRouteContext } from "@tanstack/react-router";
import QrCreator from "qr-creator";
import React, { useEffect, useRef, useState } from "react";
// import { primaryColors } from "../../../theme/theme.ts";
import Typography from "@mui/material/Typography";
import { primaryColors } from "../../theme/theme";
import { isEvyveska } from "../../utills/iframeVariants.ts";
// import { isEvyveska } from "../../../utils/iframeVariants.ts";

export const DetailQrCode = ()=>  {

  const context = useRouteContext({ from: "/inzerat" });
  const adId = context.id;
  const adUrl = `${import.meta.env.VITE_ORIGIN_DETAIL}?id=${adId}`;

  const qrcodeImage = useRef<string|null>(null);
  const [refresh,setRefresh] = useState(0);

  useEffect(() => {

    const target = document.createElement('div');
    QrCreator.render({
      "text": adUrl,
      "radius": 0.5,
      "ecLevel": "L", // error correction level, how much can be damaged (L = 7% M = 15% Q = 25% H = 30%)
      "fill": primaryColors.blue, // "#002b59" eVyveska color
      "background": null,
      "size": 200
    }, target);
    const qrcodeCanvas = target.querySelector('canvas');
    if(qrcodeCanvas) {
      qrcodeCanvas.toBlob((blob) => {
        if(blob) {
          qrcodeImage.current = URL.createObjectURL(blob);
          setRefresh(x => x+1);
        }
      });
    }
    return () => {
      if(qrcodeImage.current) {
        URL.revokeObjectURL(qrcodeImage.current);
      }
    }
  },[adUrl]);

  if(!isEvyveska()) {
    return null;
  }

  if(qrcodeImage.current) {
    return (
      <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
        <Typography
          className={'DetailQrCode-heading'}
          fontSize="1.5rem"
          variant="body1"
          color="text.primary"
          sx={{
            // padding: '2rem 0 0 0',
            // textAlign: 'center',
            display: 'block',
            textAlign: 'left',
            color: 'var(--mui-palette-info-main)',
            fontSize: '1rem',
            lineHeight: '1.75',
            fontWeight: 'bold',
            backgroundColor: 'var(--mui-palette-grey-200)',
            padding: '1.25rem 1rem',
          }}>
          Více informací o inzerátu najdete zde
        </Typography>
        <div style={{textAlign: 'left', padding: '0 0 4rem 0'}}>
          <img alt={adUrl} src={qrcodeImage.current} style={{margin: '0 0 0 2rem'}}/>
        </div>
      </div>
    );
  }

  return null;
}